// Reconstructed from the supplied production build; original component names were unavailable.
import { useAdminAuth } from "../context/AdminAuthContext.jsx";
import {
  AnimatePresence,
  CalendarIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CircleCheckBigIcon,
  CircleXIcon,
  ClockIcon,
  EyeIcon,
  FileTextIcon,
  FunnelIcon,
  MailIcon,
  MessageSquareIcon,
  PhoneIcon,
  React,
  RefreshCwIcon,
  SaveIcon,
  SearchIcon,
  SquarePenIcon,
  Trash2Icon,
  UserIcon,
  XIcon,
  jsxRuntime,
  motion,
  useNavigate,
} from "../vendor/runtime.js";
import { api } from "../services/api.js";
const RequirementsPage = () => {
  const { adminUser: e } = useAdminAuth();
  useNavigate();
  const [t, n] = React.useState([]),
    [r, a] = React.useState(true),
    [l, c] = React.useState(null),
    [d, f] = React.useState(null),
    [h, p] = React.useState(false),
    [g, y] = React.useState(""),
    [v, j] = React.useState(""),
    [N, b] = React.useState("all"),
    [S, O] = React.useState("created_at"),
    [_, C] = React.useState("desc"),
    [A, T] = React.useState(1),
    [M] = React.useState(10),
    [k, $] = React.useState({
      status: "",
      admin_notes: "",
      category: "",
      amount: "",
    }),
    projectFileRef = React.useRef(null),
    reportFileRef = React.useRef(null),
    [df, setDf] = React.useState({
      delivery_status: "",
      shipping_company: "",
      tracking_no: "",
    }),
    I = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
        },
      },
    },
    U = {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1,
        },
      },
    },
    q = async () => {
      try {
        a(true);
        const R = await api.get("/requirements");
        n(R.data || []);
      } catch (R) {
        (console.error("Error fetching requirements:", R),
          c("Failed to load project requirements"));
      } finally {
        a(false);
      }
    };
  React.useEffect(() => {
    q();
  }, []);
  const z = {
      pending: {
        color: "bg-yellow-100 text-yellow-800 border-yellow-200",
        icon: ClockIcon,
        label: "Pending",
      },
      completed: {
        color: "bg-green-100 text-green-800 border-green-200",
        icon: CircleCheckBigIcon,
        label: "Completed",
      },
      rejected: {
        color: "bg-red-100 text-red-800 border-red-200",
        icon: CircleXIcon,
        label: "Rejected",
      },
      in_progress: {
        color: "bg-purple-200 text-purple-900 border-purple-300",
        icon: RefreshCwIcon,
        label: "In Progress",
      },
    },
    Y = t
      .filter((R) => {
        var ve, te, ye;
        const W =
            ((ve = R.project_title) == null
              ? undefined
              : ve.toLowerCase().includes(v.toLowerCase())) ||
            ((te = R.name) == null ? undefined : te.toLowerCase().includes(v.toLowerCase())) ||
            ((ye = R.theme) == null ? undefined : ye.toLowerCase().includes(v.toLowerCase())),
          xe = N === "all" || R.status === N;
        return W && xe;
      })
      .sort((R, W) => {
        const xe = R[S],
          ve = W[S];
        return _ === "asc" ? (xe > ve ? 1 : -1) : xe < ve ? 1 : -1;
      }),
    F = Math.ceil(Y.length / M),
    B = (A - 1) * M,
    K = B + M,
    Q = Y.slice(B, K),
    ne = (R, W = null) => {
      (y(R),
        f(W),
        R === "edit" &&
          W &&
          $({
            status: W.status || "pending",
            admin_notes: W.admin_notes || "",
            category: W.category || "",
            amount: W.amount || "",
          }),
        R === "view" &&
          W &&
          setDf({
            delivery_status: W.delivery_status || "order received",
            shipping_company: W.shipping_company || "",
            tracking_no: W.tracking_no || "",
          }),
        p(true));
    },
    L = () => {
      (p(false),
        f(null),
        $({
          status: "",
          admin_notes: "",
          category: "",
          amount: "",
        }),
        projectFileRef.current && (projectFileRef.current.value = ""),
        reportFileRef.current && (reportFileRef.current.value = ""));
    },
    ee = async () => {
      if (!d) return;
      try {
        if (k.status === "completed") {
          const fd = new FormData();
          (fd.append("category", k.category),
            fd.append("amount", k.amount),
            fd.append("admin_notes", k.admin_notes),
            projectFileRef.current?.files?.[0] &&
              fd.append("project_file", projectFileRef.current.files[0]),
            reportFileRef.current?.files?.[0] &&
              fd.append("report_file", reportFileRef.current.files[0]));
          await api.put(`/requirements/${d.id}/complete`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        } else {
          await api.put(`/requirements/${d.id}`, {
            status: k.status,
            admin_notes: k.admin_notes,
          });
        }
        (await q(), L());
      } catch (R) {
        console.error("Error updating requirement:", R);
        alert(R.response?.data?.error || "Failed to update requirement");
      }
    },
    re = async () => {
      if (d)
        try {
          (await api.delete(`/requirements/${d.id}`), await q(), L());
        } catch (R) {
          console.error("Error deleting requirement:", R);
        }
    },
    saveDelivery = async () => {
      if (!d?.purchase_id) return;
      try {
        (await api.put(`/requirements/purchases/${d.purchase_id}/delivery`, df),
          await q(),
          L());
      } catch (R) {
        console.error("Error updating delivery status:", R);
        alert("Failed to update delivery status");
      }
    };
  return r ? (
    <div
      className={
        "admin-page flex items-center justify-center bg-gradient-to-br from-purple-50 to-purple-100"
      }
    >
      <div className={"p-8 flex flex-col items-center"}>
        <div className={"w-16 h-16 relative"}>
          <div
            className={
              "absolute inset-0 rounded-full border-t-4 border-b-4 border-purple-600 animate-spin"
            }
          />
          <div
            className={
              "absolute inset-0 rounded-full border-r-4 border-l-4 border-purple-700 animate-pulse opacity-75"
            }
          />
        </div>
      </div>
    </div>
  ) : (
    <div className={"admin-page bg-gradient-to-br from-purple-50 via-purple-100 to-purple-50"}>
      <main className="admin-main">
        <motion.div
          initial={"hidden"}
          animate={"visible"}
          variants={I}
          className={"mb-10 relative"}
        >
          
          
          <div className={"relative"}>
            <span
              className={
                "inline-block py-1 px-3 mb-3 bg-purple-100 text-purple-800 rounded-full text-sm font-medium"
              }
            >
              {"Project Requirements"}
            </span>
            <h1 className={"text-3xl md:text-4xl font-bold text-gray-900 mb-2"}>
              {"Manage "}
              <span
                className={
                  "bg-gradient-to-r from-purple-600 to-purple-800 bg-clip-text text-transparent"
                }
              >
                {"Project Requirements"}
              </span>
            </h1>
            <p className={"text-gray-600"}>
              {"Review and manage client project requirements and submissions."}
            </p>
          </div>
        </motion.div>
        <motion.div
          initial={"hidden"}
          animate={"visible"}
          variants={U}
          className={"grid grid-cols-1 md:grid-cols-4 gap-6 mb-8"}
        >
          {Object.entries(z).map(([R, W]) => {
            const xe = t.filter((te) => te.status === R).length,
              ve = W.icon;
            return (
              <motion.div
                key={R}
                variants={I}
                whileHover={{
                  y: -5,
                  transition: {
                    duration: 0.2,
                  },
                }}
                className={"bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 transition-all duration-200 hover:-translate-y-1"}
              >
                <div className={"p-4 sm:p-5"}>
                  <div className={"flex items-start justify-between gap-3"}>
                    <div className={"flex-1 min-w-0"}>
                      <p className={"text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 truncate"}>{W.label}</p>
                      <div className={"text-2xl sm:text-3xl font-extrabold text-gray-900 leading-tight"}>{xe}</div>
                    </div>
                    <div
                      className={`w-10 h-10 sm:w-12 sm:h-12 rounded-lg ${W.color.split(" ")[0]} flex items-center justify-center flex-shrink-0`}
                    >
                      {jsxRuntime.jsx(ve, {
                        className: `w-5 h-5 sm:w-6 sm:h-6 ${W.color.split(" ")[1]}`,
                      })}
                    </div>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
        <motion.div initial={"hidden"} animate={"visible"} variants={I} className={"mb-8"}>
          <div className={"bg-white rounded-2xl shadow-lg p-6 border border-gray-100"}>
            <div className={"flex flex-col lg:flex-row gap-4"}>
              <div className={"flex-1 relative"}>
                <SearchIcon
                  className={
                    "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5"
                  }
                />
                <input
                  type={"text"}
                  placeholder={"Search by project title, client name, or theme..."}
                  value={v}
                  onChange={(R) => j(R.target.value)}
                  className={
                    "w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  }
                />
              </div>
              <div className={"relative"}>
                <select
                  value={N}
                  onChange={(R) => b(R.target.value)}
                  className={
                    "appearance-none bg-white border border-gray-200 rounded-xl px-4 py-3 pr-8 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  }
                >
                  <option value={"all"}>{"All Status"}</option>
                  <option value={"pending"}>{"Pending"}</option>
                  <option value={"completed"}>{"Completed"}</option>
                  <option value={"rejected"}>{"Rejected"}</option>
                  <option value={"in_progress"}>{"In Progress"}</option>
                </select>
                <FunnelIcon
                  className={
                    "absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 pointer-events-none"
                  }
                />
              </div>
              <div className={"flex gap-2"}>
                <select
                  value={S}
                  onChange={(R) => O(R.target.value)}
                  className={
                    "bg-white border border-gray-200 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  }
                >
                  <option value={"created_at"}>{"Date Created"}</option>
                  <option value={"project_title"}>{"Project Title"}</option>
                  <option value={"name"}>{"Client Name"}</option>
                  <option value={"status"}>{"Status"}</option>
                </select>
                <button
                  onClick={() => C(_ === "asc" ? "desc" : "asc")}
                  className={
                    "bg-white border border-gray-200 rounded-xl px-4 py-3 hover:bg-gray-50 transition-colors"
                  }
                >
                  {_ === "asc" ? "↑" : "↓"}
                </button>
              </div>
              <button
                onClick={q}
                className={
                  "bg-purple-600 text-white px-6 py-3 rounded-xl hover:bg-purple-700 transition duration-200 flex items-center"
                }
              >
                <RefreshCwIcon className={"w-5 h-5 mr-2"} />
                {"Refresh"}
              </button>
            </div>
          </div>
        </motion.div>
        <motion.div initial={"hidden"} animate={"visible"} variants={I} className={"mb-8"}>
          <div className={"bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100"}>
            {Q.length > 0 ? (
              <jsxRuntime.Fragment>
                <div className={"px-6 py-4 border-b border-gray-200 bg-gray-50"}>
                  <div className={"flex justify-between items-center"}>
                    <div className={"text-sm text-gray-600"}>
                      {"Showing "}
                      {B + 1}
                      {"-"}
                      {Math.min(K, Y.length)}
                      {" of "}
                      {Y.length}
                      {" requirements"}
                    </div>
                    <div className={"text-sm text-gray-600"}>
                      {"Page "}
                      {A}
                      {" of "}
                      {F}
                    </div>
                  </div>
                </div>
                <div className={"overflow-x-auto"}>
                  <table className={"min-w-full divide-y divide-gray-200"}>
                    <thead>
                      <tr>
                        <th
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Client & Project"}
                        </th>
                        <th
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Theme"}
                        </th>
                        <th
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Status"}
                        </th>
                        <th
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Date"}
                        </th>
                        <th
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Actions"}
                        </th>
                      </tr>
                    </thead>
                    <tbody className={"bg-white divide-y divide-gray-200"}>
                      {Q.map((R) => {
                        const W = z[R.status] || z.pending,
                          xe = W.icon;
                        return (
                          <tr key={R.id} className={"hover:bg-gray-50 transition duration-150"}>
                            <td className={"px-6 py-4"}>
                              <div className={"flex items-center"}>
                                <div
                                  className={
                                    "flex-shrink-0 h-10 w-10 bg-purple-100 rounded-full flex items-center justify-center"
                                  }
                                >
                                  <UserIcon className={"w-5 h-5 text-purple-600"} />
                                </div>
                                <div className={"ml-4"}>
                                  <div className={"text-sm font-medium text-gray-900"}>
                                    {R.name}
                                  </div>
                                  <div className={"text-sm text-gray-500"}>{R.project_title}</div>
                                  <div className={"text-xs text-gray-400 flex items-center mt-1"}>
                                    <MailIcon className={"w-3 h-3 mr-1"} />
                                    {R.email}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className={"px-6 py-4"}>
                              <span
                                className={
                                  "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-200 text-purple-900"
                                }
                              >
                                {R.theme}
                              </span>
                            </td>
                            <td className={"px-6 py-4"}>
                              <span
                                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${W.color}`}
                              >
                                {jsxRuntime.jsx(xe, {
                                  className: "w-3 h-3 mr-1",
                                })}
                                {W.label}
                              </span>
                            </td>
                            <td className={"px-6 py-4 text-sm text-gray-500"}>
                              <div className={"flex items-center"}>
                                <CalendarIcon className={"w-4 h-4 mr-2 text-gray-400"} />
                                {new Date(R.created_at).toLocaleDateString()}
                              </div>
                            </td>
                            <td className={"px-6 py-4"}>
                              <div className={"flex items-center space-x-2"}>
                                <button
                                  onClick={() => ne("view", R)}
                                  className={
                                    "text-purple-800 hover:text-purple-900 p-2 rounded-lg hover:bg-purple-100 transition-colors"
                                  }
                                  title={"View Details"}
                                >
                                  <EyeIcon className={"w-4 h-4"} />
                                </button>
                                <button
                                  onClick={() => ne("edit", R)}
                                  className={
                                    "text-green-600 hover:text-green-800 p-2 rounded-lg hover:bg-green-50 transition-colors"
                                  }
                                  title={"Edit"}
                                >
                                  <SquarePenIcon className={"w-4 h-4"} />
                                </button>
                                <button
                                  onClick={() => ne("delete", R)}
                                  className={
                                    "text-red-600 hover:text-red-800 p-2 rounded-lg hover:bg-red-50 transition-colors"
                                  }
                                  title={"Delete"}
                                >
                                  <Trash2Icon className={"w-4 h-4"} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                {F > 1 && (
                  <div className={"bg-white px-4 py-3 border-t border-gray-200"}>
                    <div className={"flex items-center justify-between"}>
                      <div className={"flex-1 flex justify-between sm:hidden"}>
                        <button
                          onClick={() => T(Math.max(1, A - 1))}
                          disabled={A === 1}
                          className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${A === 1 ? "text-gray-400 bg-gray-100 cursor-not-allowed" : "text-gray-700 bg-white hover:bg-gray-50"}`}
                        >
                          {"Previous"}
                        </button>
                        <button
                          onClick={() => T(Math.min(F, A + 1))}
                          disabled={A === F}
                          className={`ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${A === F ? "text-gray-400 bg-gray-100 cursor-not-allowed" : "text-gray-700 bg-white hover:bg-gray-50"}`}
                        >
                          {"Next"}
                        </button>
                      </div>
                      <div
                        className={"hidden sm:flex-1 sm:flex sm:items-center sm:justify-between"}
                      >
                        <div>
                          <p className={"text-sm text-gray-700"}>
                            {"Showing "}
                            <span className={"font-medium"}>{B + 1}</span>
                            {" to"} <span className={"font-medium"}>{Math.min(K, Y.length)}</span>
                            {" of"} <span className={"font-medium"}>{Y.length}</span>
                            {" results"}
                          </p>
                        </div>
                        <div>
                          <nav
                            className={"relative z-0 inline-flex rounded-md shadow-sm -space-x-px"}
                          >
                            <button
                              onClick={() => T(Math.max(1, A - 1))}
                              disabled={A === 1}
                              className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 text-sm font-medium ${A === 1 ? "text-gray-400 bg-gray-100 cursor-not-allowed" : "text-gray-500 bg-white hover:bg-gray-50"}`}
                            >
                              <ChevronLeftIcon className={"h-5 w-5"} />
                            </button>
                            {Array.from(
                              {
                                length: F,
                              },
                              (R, W) => W + 1,
                            ).map((R) => (
                              <button
                                key={R}
                                onClick={() => T(R)}
                                className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${R === A ? "z-10 bg-purple-50 border-purple-500 text-purple-600" : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"}`}
                              >
                                {R}
                              </button>
                            ))}
                            <button
                              onClick={() => T(Math.min(F, A + 1))}
                              disabled={A === F}
                              className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 text-sm font-medium ${A === F ? "text-gray-400 bg-gray-100 cursor-not-allowed" : "text-gray-500 bg-white hover:bg-gray-50"}`}
                            >
                              <ChevronRightIcon className={"h-5 w-5"} />
                            </button>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </jsxRuntime.Fragment>
            ) : (
              <div className={"p-12 text-center"}>
                <div className={"flex flex-col items-center justify-center space-y-4"}>
                  <div
                    className={
                      "w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center"
                    }
                  >
                    <FileTextIcon className={"h-8 w-8 text-gray-400"} />
                  </div>
                  <div>
                    <h3 className={"text-xl font-bold text-gray-800 mb-1"}>
                      {"No Requirements Found"}
                    </h3>
                    <p className={"text-gray-500"}>
                      {"No project requirements match your current filters"}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </motion.div>
      </main>
      <AnimatePresence>
        {h && d && (
          <motion.div
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            exit={{
              opacity: 0,
            }}
            className={
              "fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
            }
            onClick={L}
          >
            <motion.div
              initial={{
                scale: 0.95,
                opacity: 0,
              }}
              animate={{
                scale: 1,
                opacity: 1,
              }}
              exit={{
                scale: 0.95,
                opacity: 0,
              }}
              onClick={(R) => R.stopPropagation()}
              className={
                "bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
              }
            >
              <div
                className={
                  "sticky top-0 bg-white px-6 py-4 border-b border-gray-200 flex justify-between items-center rounded-t-2xl"
                }
              >
                <h2 className={"text-xl font-bold text-gray-800"}>
                  {g === "view" && "View Requirement Details"}
                  {g === "edit" && "Edit Requirement"}
                  {g === "delete" && "Delete Requirement"}
                </h2>
                <button
                  onClick={L}
                  className={"p-2 hover:bg-gray-100 rounded-lg transition-colors"}
                >
                  <XIcon className={"w-5 h-5"} />
                </button>
              </div>
              <div className={"px-6 py-6"}>
                {g === "view" && (
                  <div className={"space-y-6"}>
                    <div className={"bg-gray-50 rounded-xl p-6"}>
                      <h3 className={"text-lg font-semibold text-gray-800 mb-4 flex items-center"}>
                        <UserIcon className={"w-5 h-5 mr-2"} />
                        {"Client Information"}
                      </h3>
                      <div className={"grid grid-cols-1 md:grid-cols-2 gap-4"}>
                        <div>
                          <label className={"text-sm font-medium text-gray-500"}>{"Name"}</label>
                          <p className={"text-gray-800 font-medium"}>{d.name}</p>
                        </div>
                        <div>
                          <label className={"text-sm font-medium text-gray-500"}>{"Email"}</label>
                          <p className={"text-gray-800 flex items-center"}>
                            <MailIcon className={"w-4 h-4 mr-2 text-gray-400"} />
                            {d.email}
                          </p>
                        </div>
                        <div>
                          <label className={"text-sm font-medium text-gray-500"}>{"Phone"}</label>
                          <p className={"text-gray-800 flex items-center"}>
                            <PhoneIcon className={"w-4 h-4 mr-2 text-gray-400"} />
                            {d.phone}
                          </p>
                        </div>
                        <div>
                          <label className={"text-sm font-medium text-gray-500"}>
                            {"Submitted"}
                          </label>
                          <p className={"text-gray-800 flex items-center"}>
                            <CalendarIcon className={"w-4 h-4 mr-2 text-gray-400"} />
                            {new Date(d.created_at).toLocaleDateString()}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className={"bg-purple-100 rounded-xl p-6"}>
                      <h3 className={"text-lg font-semibold text-gray-800 mb-4 flex items-center"}>
                        <FileTextIcon className={"w-5 h-5 mr-2"} />
                        {"Project Details"}
                      </h3>
                      <div className={"space-y-4"}>
                        <div>
                          <label className={"text-sm font-medium text-gray-500"}>
                            {"Project Title"}
                          </label>
                          <p className={"text-gray-800 font-medium"}>{d.project_title}</p>
                        </div>
                        <div>
                          <label className={"text-sm font-medium text-gray-500"}>{"Theme"}</label>
                          <span
                            className={
                              "inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-purple-200 text-purple-900"
                            }
                          >
                            {d.theme}
                          </span>
                        </div>
                        <div>
                          <label className={"text-sm font-medium text-gray-500"}>
                            {"Message/Requirements"}
                          </label>
                          <p
                            className={
                              "text-gray-800 whitespace-pre-wrap mt-2 p-4 bg-white rounded-lg border"
                            }
                          >
                            {d.message}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className={"bg-green-50 rounded-xl p-6"}>
                      <h3 className={"text-lg font-semibold text-gray-800 mb-4 flex items-center"}>
                        <MessageSquareIcon className={"w-5 h-5 mr-2"} />
                        {"Status & Admin Notes"}
                      </h3>
                      <div className={"space-y-4"}>
                        <div>
                          <label className={"text-sm font-medium text-gray-500"}>
                            {"Current Status"}
                          </label>
                          <div className={"mt-2"}>
                            {(() => {
                              const R = z[d.status],
                                W = R.icon;
                              return (
                                <span
                                  className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${R.color}`}
                                >
                                  <W className={"w-4 h-4 mr-1"} />
                                  {R.label}
                                </span>
                              );
                            })()}
                          </div>
                        </div>
                        {d.admin_notes && (
                          <div>
                            <label className={"text-sm font-medium text-gray-500"}>
                              {"Admin Notes"}
                            </label>
                            <p
                              className={
                                "text-gray-800 whitespace-pre-wrap mt-2 p-4 bg-white rounded-lg border"
                              }
                            >
                              {d.admin_notes}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                    {d.status === "completed" && (
                      <div className={"bg-purple-50 rounded-xl p-6"}>
                        <h3 className={"text-lg font-semibold text-gray-800 mb-4"}>
                          {"Payment & Delivery"}
                        </h3>
                        <div className={"space-y-4"}>
                          <div className={"grid grid-cols-1 md:grid-cols-2 gap-4"}>
                            <div>
                              <label className={"text-sm font-medium text-gray-500"}>
                                {"Price"}
                              </label>
                              <p className={"text-gray-800 font-medium"}>
                                {d.amount ? `₹${d.amount}` : "Not set"}
                              </p>
                            </div>
                            <div>
                              <label className={"text-sm font-medium text-gray-500"}>
                                {"Payment"}
                              </label>
                              <p className={"text-gray-800 font-medium"}>
                                {d.payment_status === "paid" ? "Paid" : "Awaiting payment"}
                              </p>
                            </div>
                          </div>
                          {d.payment_status === "paid" && d.category === "hardware" && (
                            <div className={"border-t border-purple-200 pt-4 space-y-4"}>
                              <p className={"text-sm font-medium text-gray-700"}>
                                {"Shipping (hardware order)"}
                              </p>
                              <div>
                                <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                                  {"Delivery Status"}
                                </label>
                                <select
                                  value={df.delivery_status}
                                  onChange={(R) =>
                                    setDf({ ...df, delivery_status: R.target.value })
                                  }
                                  className={
                                    "w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                                  }
                                >
                                  <option value={"order received"}>{"Order Received"}</option>
                                  <option value={"in process"}>{"In Process"}</option>
                                  <option value={"shipped"}>{"Shipped"}</option>
                                  <option value={"delivered"}>{"Delivered"}</option>
                                  <option value={"cancelled"}>{"Cancelled"}</option>
                                </select>
                              </div>
                              <div className={"grid grid-cols-1 md:grid-cols-2 gap-4"}>
                                <div>
                                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                                    {"Shipping Company"}
                                  </label>
                                  <input
                                    type={"text"}
                                    value={df.shipping_company}
                                    onChange={(R) =>
                                      setDf({ ...df, shipping_company: R.target.value })
                                    }
                                    className={
                                      "w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                                    }
                                    placeholder={"e.g. Delhivery"}
                                  />
                                </div>
                                <div>
                                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                                    {"Tracking Number"}
                                  </label>
                                  <input
                                    type={"text"}
                                    value={df.tracking_no}
                                    onChange={(R) =>
                                      setDf({ ...df, tracking_no: R.target.value })
                                    }
                                    className={
                                      "w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                                    }
                                    placeholder={"Tracking ID"}
                                  />
                                </div>
                              </div>
                              <button
                                onClick={saveDelivery}
                                className={
                                  "px-5 py-2.5 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-colors text-sm font-medium"
                                }
                              >
                                {"Save Tracking Info"}
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {g === "edit" && (
                  <div className={"space-y-6"}>
                    <div className={"bg-gray-50 rounded-xl p-6"}>
                      <h3 className={"text-lg font-semibold text-gray-800 mb-4"}>
                        {"Edit Requirement: "}
                        {d.project_title}
                      </h3>
                      <div className={"space-y-4"}>
                        <div>
                          <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                            {"Status"}
                          </label>
                          <select
                            value={k.status}
                            onChange={(R) =>
                              $({
                                ...k,
                                status: R.target.value,
                              })
                            }
                            className={
                              "w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                            }
                          >
                            <option value={"pending"}>{"Pending"}</option>
                            <option value={"completed"}>{"Completed"}</option>
                            <option value={"rejected"}>{"Rejected"}</option>
                            <option value={"in_progress"}>{"In Progress"}</option>
                          </select>
                        </div>
                        <div>
                          <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                            {"Admin Notes"}
                          </label>
                          <textarea
                            value={k.admin_notes}
                            onChange={(R) =>
                              $({
                                ...k,
                                admin_notes: R.target.value,
                              })
                            }
                            rows={4}
                            className={
                              "w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                            }
                            placeholder={"Add notes for the client..."}
                          />
                        </div>
                        {k.status === "completed" && (
                          <div className={"border-t border-gray-200 pt-4 space-y-4"}>
                            <p className={"text-sm font-medium text-gray-700"}>
                              {"Deliver this project — sets the price the client pays and unlocks their Pay Now button."}
                            </p>
                            <div>
                              <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                                {"Category"}
                              </label>
                              <select
                                value={k.category}
                                onChange={(R) => $({ ...k, category: R.target.value })}
                                className={
                                  "w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                                }
                              >
                                <option value={""}>{"Select category"}</option>
                                <option value={"software"}>{"Software"}</option>
                                <option value={"hardware"}>{"Hardware (needs shipping/tracking)"}</option>
                              </select>
                            </div>
                            <div>
                              <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                                {"Amount (₹)"}
                              </label>
                              <input
                                type={"number"}
                                min={"1"}
                                step={"0.01"}
                                value={k.amount}
                                onChange={(R) => $({ ...k, amount: R.target.value })}
                                className={
                                  "w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                                }
                                placeholder={"e.g. 1499"}
                              />
                            </div>
                            <div>
                              <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                                {"Project File"}
                                {d.project_file && (
                                  <span className={"text-gray-400 font-normal"}>
                                    {" (already uploaded — pick a new one to replace it)"}
                                  </span>
                                )}
                              </label>
                              <input
                                type={"file"}
                                ref={projectFileRef}
                                className={
                                  "w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm"
                                }
                              />
                            </div>
                            <div>
                              <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                                {"Report File (optional)"}
                                {d.report_file && (
                                  <span className={"text-gray-400 font-normal"}>
                                    {" (already uploaded — pick a new one to replace it)"}
                                  </span>
                                )}
                              </label>
                              <input
                                type={"file"}
                                ref={reportFileRef}
                                className={
                                  "w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm"
                                }
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {g === "delete" && (
                  <div className={"text-center py-8"}>
                    <div
                      className={
                        "w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4"
                      }
                    >
                      <Trash2Icon className={"w-8 h-8 text-red-600"} />
                    </div>
                    <h3 className={"text-xl font-bold text-gray-800 mb-2"}>
                      {"Delete Requirement"}
                    </h3>
                    <p className={"text-gray-600 mb-6"}>
                      {'Are you sure you want to delete the requirement "'}
                      {d.project_title}
                      {'"? This action cannot be undone.'}
                    </p>
                  </div>
                )}
              </div>
              <div
                className={
                  "sticky bottom-0 bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end space-x-3 rounded-b-2xl"
                }
              >
                <button
                  onClick={L}
                  className={
                    "px-6 py-3 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors"
                  }
                >
                  {g === "view" ? "Close" : "Cancel"}
                </button>
                {g === "edit" && (
                  <button
                    onClick={ee}
                    className={
                      "px-6 py-3 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-colors flex items-center"
                    }
                  >
                    <SaveIcon className={"w-5 h-5 mr-2"} />
                    {"Update & Notify"}
                  </button>
                )}
                {g === "delete" && (
                  <button
                    onClick={re}
                    className={
                      "px-6 py-3 bg-red-600 text-white rounded-xl hover:bg-red-700 transition-colors flex items-center"
                    }
                  >
                    <Trash2Icon className={"w-5 h-5 mr-2"} />
                    {"Delete"}
                  </button>
                )}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
export { RequirementsPage };
